// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"properties-icon-wrapper_iconsWrapper__3QPjy","icon":"properties-icon-wrapper_icon__C6elB"};